export default "__VITE_ASSET__UUvMGrBR__"